// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2156":"7b86a814","2890":"6f3eec0f","4845":"3b53517f","4943":"3b53517f","7778":"f8de5290"}[chunkId] + ".chunk.css";
};